export default "__VITE_ASSET__DVCXYiHh__"